import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function ServicesPage() {
  const services = [
    { title: "Constitutional, Election and Judicial Review Matters", desc: "Representation in constitutional petitions, election disputes, and applications for judicial review." },
    { title: "Employment and Labour Relation Matters", desc: "Legal support on employment disputes, contracts, workplace policies, and compliance with labour laws." },
    { title: "Banking and Securities", desc: "Advice on lending, securitization, debt recovery, and banking compliance matters." },
    { title: "Civil Litigation", desc: "Representation in civil disputes including torts, contracts, and commercial litigation." },
    { title: "Commercial Contracts and Transactions", desc: "Drafting, negotiation, and review of commercial contracts, joint ventures, and strategic partnerships." },
    { title: "Consultancy (Legal opinions, Company Secretarial Services)", desc: "Delivery of legal opinions and ongoing company secretarial services for corporate clients." },
    { title: "Environment and Land Law", desc: "Legal counsel on environmental compliance, land use, real estate transactions, and land disputes." },
    { title: "Insurance Law", desc: "Representation in insurance claims, coverage disputes, and advisory on regulatory compliance." },
    { title: "Intellectual Property", desc: "Registration, protection, and enforcement of trademarks, patents, and copyrights." },
    { title: "Joint Ventures", desc: "Structuring and negotiating joint ventures, mergers, acquisitions, and partnerships." },
    { title: "Trusts (including Charitable Trusts)", desc: "Establishment, administration, and compliance of private and charitable trusts." },
    { title: "Winding Up & Liquidation", desc: "Legal support for company dissolution, insolvency proceedings, and liquidation strategies." }
  ];

  return (
    <div className="bg-gray-50 text-deepgreen min-h-screen font-sans">
      <Navbar />

      {/* Header Section */}
      <section className="bg-deepgreen text-white py-24 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-extrabold mb-6" data-aos="fade-up">
            Our Legal Services
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="100">
            We provide comprehensive legal services across key areas of practice, tailored to meet your specific needs with precision and integrity.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="px-6 py-20 max-w-7xl mx-auto -mt-16 relative z-10">
        <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-left">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-xl border-t-4 border-gold hover:-translate-y-2 transition duration-300 flex flex-col"
              data-aos="fade-up"
              data-aos-delay={index * 50}
            >
              <h3 className="text-xl font-serif font-bold mb-4 text-deepgreen">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed flex-grow">
                {service.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ServicesPage;
